export default __webpack_public_path__ + "8d7131dfb1091fe51844583d125e5a21.jpg";